var map = {
	"./-m-mine.svg": 9902,
	"./address.svg": 8543,
	"./bug.svg": 4174,
	"./ces.svg": 881,
	"./enterAccount.svg": 847,
	"./funcUser.svg": 8654,
	"./home.svg": 7349,
	"./info.svg": 2509,
	"./invoice.svg": 9532,
	"./myAccount.svg": 7360,
	"./news.svg": 2031,
	"./notice.svg": 2858,
	"./order.svg": 9034,
	"./recommend.svg": 2072,
	"./user.svg": 3447,
	"./userInfo.svg": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;